<template>
  <dialog-reset
    title="配件入库登记"
    :visible.sync="visible"
    width="600px"
    top="10vh"
    height="auto"
    :close-on-click-modal="false"
    :zoomShow="false"
    @close="handleClose"
  >
    <div class="part-info">
      <div class="info-item">
        <div class="info-label">配件编码</div>
        <div class="info-value">{{ partData.partCode || '-' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">配件名称</div>
        <div class="info-value">{{ partData.partName || '-' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">当前库存</div>
        <div class="info-value">{{ partData.stockCount || 0 }} {{ partData.unit || '个' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">最低库存</div>
        <div class="info-value">{{ partData.minimumStock || 0 }} {{ partData.unit || '个' }}</div>
      </div>
    </div>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      size="small"
      style="margin-top: 20px"
    >
      <el-form-item label="入库数量" prop="quantity">
        <el-input-number
          v-model="form.quantity"
          :min="0.01"
          :precision="2"
          :step="1"
          placeholder="请输入入库数量"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="入库类型" prop="inboundType">
        <el-select v-model="form.inboundType" placeholder="请选择入库类型" style="width: 100%">
          <el-option
            v-for="item in inboundTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="批次号/序列号">
        <el-input
          v-model="form.batchNo"
          placeholder="如有批次号请填写"
          maxlength="100"
        />
      </el-form-item>
      <el-form-item label="关联单号">
        <el-input
          v-model="form.relatedOrderNo"
          placeholder="如采购单号、调拨单号"
          maxlength="100"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="填写入库说明"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <span slot="dialog_footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
    </span>
  </dialog-reset>
</template>

<script>
import { inbound } from '../api'

export default {
  name: 'InboundDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    partData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      submitting: false,
      form: {
        partId: null,
        quantity: null,
        inboundType: '',
        batchNo: '',
        relatedOrderNo: '',
        remark: ''
      },
      rules: {
        quantity: [
          { required: true, message: '请输入入库数量', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '入库数量必须大于0', trigger: 'blur' }
        ],
        inboundType: [
          { required: true, message: '请选择入库类型', trigger: 'change' }
        ]
      },
      inboundTypeOptions: [
        { label: '采购入库', value: 'purchase' },
        { label: '调拨入库', value: 'transfer' },
        { label: '退货入库', value: 'return' },
        { label: '盘盈入库', value: 'inventory_gain' },
        { label: '其他', value: 'other' }
      ]
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.partId = this.partData.id
        this.form = {}
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate()
        })
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true
          inbound({
            id: this.partData.id,
            stockCount: this.partData.stockCount || 0,
            inboundCount: this.form.quantity
          }).then(() => {
            this.$message.success('入库成功')
            this.$emit('success')
            this.submitting = false
            this.handleClose()
          }).catch(() => {
            this.submitting = false
          })
        }
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="scss">
.part-info {
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  .info-item {
    width: 50%;
    margin-bottom: 12px;
    .info-label {
      font-size: 12px;
      color: #999;
      margin-bottom: 4px;
    }
    .info-value {
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
  }
}
</style>
